import * as React from "react";
const SvgTariffProfessionalCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, rx: 20, fill: "white" }),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5407_36545)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.4032 11.0723C14.584 10.8272 14.8733 10.6786 15.1786 10.6786H24.8215C25.1268 10.6786 25.4161 10.8232 25.5969 11.0723L30.0969 17.1795C30.3701 17.5491 30.342 18.0594 30.0366 18.4009L20.7152 28.6866C20.5344 28.8875 20.2733 29.004 20 29.004C19.7268 29.004 19.4697 28.8875 19.2849 28.6866L9.96343 18.4009C9.65406 18.0594 9.62995 17.5491 9.90317 17.1795L14.4032 11.0723ZM15.95 12.6714C15.8175 12.7719 15.7813 12.9527 15.8657 13.0933L18.1719 16.9344L12.2576 17.4286C12.0929 17.4406 11.9643 17.5813 11.9643 17.75C11.9643 17.9188 12.0929 18.0554 12.2576 18.0714L19.9719 18.7143H20.0241L27.7384 18.0714C27.9032 18.0594 28.0317 17.9188 28.0317 17.75C28.0317 17.5813 27.9032 17.4447 27.7384 17.4286L21.8282 16.9384L24.1344 13.0973C24.2188 12.9567 24.1826 12.7719 24.05 12.6755C23.9175 12.579 23.7326 12.5951 23.6201 12.7156L20 16.6331L16.38 12.7116C16.2675 12.5911 16.0826 12.575 15.95 12.6714Z",
      fill: "#F86EB3"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5407_36545" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: 20.5714,
      height: 20.5714,
      fill: "white",
      transform: "translate(9.71429 9.71423)"
    }
  )))
);
export default SvgTariffProfessionalCircle;
